var Backbone = require('backbone');


module.exports = Backbone.Model.extend({

    idAttribute: 'key',

    defaults: {
        key: '',
        keyNoSymbol: '', // ( not the first letter )
        value: '',
        isValid: false // no entered ( maybe later too long )
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/textStamp/variableInputs/dynamicInput.js
 ** module id = 341
 ** module chunks = 0
 **/